import { SMART_CONTRACT_PLUGIN_CATEGORIES } from "@/components/SmartContractDesigner/pluginCategories";
import { SELECTED_PLUGIN_INFORMATION_DATA } from "./const/selectedPluginInformationData";

export default {
    smartContractPluginCategories: SMART_CONTRACT_PLUGIN_CATEGORIES,
    selectedPluginInformationData: SELECTED_PLUGIN_INFORMATION_DATA,
    selectedPluginCode: null,
    selectedPluginUuid: null,
    selectedPluginData: [],
    selectedFunction: null,
    applicationFunctions: [],
    smartContractList: [],
    functionSelected: [],
    staticVariables: [],
    existingFunctionsAsDDL: [],
    appBlockchainLanguage: null,
    inEditFunction: null,
    formattedPreviewFunction: null,
    formattedSmartContract: null,
    functionsSignatures: [],
    ddlType: [],
    smartContractValidationModel: null,
    redoCache: {},
    diagramValidationErr: false,
    saveDigramaData: false,
    bcTypes: [],
    bcNetworks: [],
    bcCredentials: [],
    scNumber: null,
    currentContract: null,
    scSameNetwork: null,
    events: null,
    templates: null
};
